module.exports = __webpack_public_path__ + "static/media/miles-info.d7f9b79f.svg";